"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUndef = exports.isString = exports.isObject = exports.isNumber = exports.isFunction = exports.isBoolean = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var isObject = exports.isObject = function isObject(value) {
  return value !== null && (0, _typeof2["default"])(value) === 'object';
};
var isFunction = exports.isFunction = function isFunction(value) {
  return typeof value === 'function';
};
var isString = exports.isString = function isString(value) {
  return typeof value === 'string';
};
var isBoolean = exports.isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
var isNumber = exports.isNumber = function isNumber(value) {
  return typeof value === 'number';
};
var isUndef = exports.isUndef = function isUndef(value) {
  return typeof value === 'undefined';
};